@use '~@cewe-designsystem-stylecomponents/mixins/breakpoints';
@use 'config' as config;

:host {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  background-color: config.$keyvisual-background-color;

  .download {
    max-width: 600px;
    margin: 0 auto;
    padding: 1rem 0.5rem;
  }

  // mobile first (stacked view)
  slot[name='download-content-desktop-column'],
  slot[name='download-content-mobile-column'] {
    display: block;
  }

  slot[name='download-content-desktop-row'],
  slot[name='download-content-mobile-row'] {
    display: none;
  }

  // row view
  @include breakpoints.breakpoint('md', 'up') {
    flex-direction: row-reverse;

    .brandvisual {
      flex-basis: 66.67%;
      overflow: hidden;
    }

    .download {
      flex-basis: 33.33%;
      max-width: initial;
      margin: 0;
      padding: 0;
      overflow: hidden;
    }

    slot[name='download-content-desktop-column'],
    slot[name='download-content-mobile-column'] {
      display: none;
    }

    slot[name='download-content-desktop-row'],
    slot[name='download-content-mobile-row'] {
      display: block;
    }
  }
}

:host([desktop='true']) {
  slot[name='download-content-mobile-row'],
  slot[name='download-content-mobile-column'] {
    display: none;
  }
}

:host([desktop='false']) {
  slot[name='download-content-desktop-row'],
  slot[name='download-content-desktop-column'] {
    display: none;
  }
}

:host(.reverse) {
  @include breakpoints.breakpoint('md', 'up') {
    flex-direction: row;
  }
}
